type LogoMarkProps = {
  className?: string;
  title?: string;
};

/**
 * Brand mark for Car Rental Bucharest: an open gold "C" arc closed by a road
 * stripe, set in an ink badge. Drawn as paths so it stays crisp at favicon size.
 */
export function LogoMark({ className, title = "Car Rental Bucharest" }: LogoMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label={title}
      focusable="false"
    >
      <defs>
        <linearGradient id="brand-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E7CE93" />
          <stop offset="0.5" stopColor="#C9A961" />
          <stop offset="1" stopColor="#9C7C3B" />
        </linearGradient>
        <linearGradient id="brand-ink" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1C1C1C" />
          <stop offset="1" stopColor="#0A0A0A" />
        </linearGradient>
      </defs>
      <rect
        x="1.5"
        y="1.5"
        width="61"
        height="61"
        rx="15"
        fill="url(#brand-ink)"
        stroke="url(#brand-gold)"
        strokeWidth="3"
      />
      <path
        d="M45 20.5A18 18 0 1 0 45 43.5"
        fill="none"
        stroke="url(#brand-gold)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <rect x="34" y="28.5" width="17" height="7" rx="3.5" fill="url(#brand-gold)" />
    </svg>
  );
}
